import { Controller, Control } from 'react-hook-form'
import { FileInput } from '../common/input/FileInput'

type FormFileInputProps = {
  name: string
  label?: string
  placeholder?: string
  control: Control<any>
  required?: boolean
  accept?: string
  multiple?: boolean
  errorMessage?: string
  fullWidth?: boolean
  onClear?: () => void
}

export const FormFileInput = ({
  name,
  label,
  placeholder,
  control,
  required = false,
  accept,
  multiple = false,
  errorMessage,
  fullWidth = false,
  onClear
}: FormFileInputProps) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={{
        required: required ? 'File is required' : false,
        validate: value => {
          if (required && (!value || value.length === 0)) {
            return 'File is required'
          }

          return true
        }
      }}
      render={({ field, fieldState }) => (
        <FileInput
          {...field}
          label={label}
          placeholder={placeholder}
          required={required}
          accept={accept}
          multiple={multiple}
          fullWidth={fullWidth}
          error={!!fieldState.error || !!errorMessage}
          helperText={fieldState.error?.message || errorMessage}
          onChange={files => {
            field.onChange(files)
          }}
          onClear={onClear}
        />
      )}
    />
  )
}

export default FormFileInput
